import axiosInstance from '../lib/axios';

/**
 * Fetch all notifications
 * Optionally can filter by userId and viewed
 */
export const fetchNotifications = async ({ queryKey }) => {
   const [_key, params = {}] = queryKey;
   const response = await axiosInstance.get('/admin/notifications', {
    params,
  });
  return response.data;
};

/**
 * Update notification read/unread status
 */
export const updateNotificationStatus = async (id, viewed) => {
  try {
    const response = await axiosInstance.patch(`/admin/notifications/${id}`, { viewed });
    return response.data;
  } catch (error) {
    console.error('Error updating notification status:', error);
    throw error;
  }
};

/**
 * Mark all notifications as read for a specific user
 */
export const markAllNotificationsAsRead = async (userId) => {
  try {
    const response = await axiosInstance.patch('/admin/notifications/mark-all', { userId });
    return response.data;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw error;
  }
};
